import { render, staticRenderFns } from "./Kiosks.vue?vue&type=template&id=394b828a&scoped=true&lang=pug"
import script from "./Kiosks.vue?vue&type=script&lang=js"
export * from "./Kiosks.vue?vue&type=script&lang=js"
import style0 from "./Kiosks.vue?vue&type=style&index=0&id=394b828a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b828a",
  null
  
)

export default component.exports